import axios from "../axios-auth";
import orginal_axios from "axios";

export const wholeSaleService = {
  getWholeSaleList,
  save,
  getWholeSaleDetail,
  printInvoiceById,
  showWindowDialog,
  getUnfinishedWholeSale,
  getAllWholeSaleList,
  exportWholeSaleExcel,
  getWholeSaleSummary
};

function getWholeSaleList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (typeof (searchParams.isOrderWholeSale) == 'boolean') {
    params["isOrderWholeSale"] = searchParams.isOrderWholeSale;
  }
  if (typeof (searchParams.isStockIssue) == 'boolean') {
    params["isStockIssue"] = searchParams.isStockIssue;
  }
  if (searchParams.orderType) {
    params["orderType"] = searchParams.orderType;
  }
  if (searchParams.orderWarehouseId) {
    params["orderWarehouseId"] = searchParams.orderWarehouseId;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.saleTeamIds) {
    params["saleTeamIds"] = searchParams.saleTeamIds.join();
  }
  if (searchParams.ordNo) {
    params["ordNo"] = searchParams.ordNo;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  return axios.get("/auth/whole-sales", { params });
}

function getWholeSaleSummary(searchParams) {
  let params = {};

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.orderType) {
    params["orderType"] = searchParams.orderType;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.saleTeamIds) {
    params["saleTeamIds"] = searchParams.saleTeamIds.join();
  }
  if (searchParams.ordNo) {
    params["ordNo"] = searchParams.ordNo;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  return axios.get("/auth/whole-sales-summary", { params });
}

function save(wholeSale) {
  if (!wholeSale.id) {
    // new wholeSale
    return axios.post("/auth/whole-sale", wholeSale);
  } else {
    // edit
    return axios.put("/auth/whole-sale", wholeSale);
  }
}

function getWholeSaleDetail(id) {
  return axios.get("/auth/whole-sale/" + id);
}

function printInvoiceById(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-whole-sale-invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

function getUnfinishedWholeSale(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  return axios.get("/auth/unfinished-whole-sales", { params });
}

function getAllWholeSaleList(searchParams) {
  let params = {};
  
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }

  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }

  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }

  if (searchParams.orderType) {
    params["orderType"] = searchParams.orderType;
  }

  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.saleTeamIds) {
    params["saleTeamIds"] = searchParams.saleTeamIds.join();
  }
  if (searchParams.ordNo) {
    params["ordNo"] = searchParams.ordNo;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }

  return axios.get("/auth/whole-sales", { params });
}

function exportWholeSaleExcel(searchParams) {
  let params = {};
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }

  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }

  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }

  if (searchParams.orderType) {
    params["orderType"] = searchParams.orderType;
  }

  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.saleTeamIds) {
    params["saleTeamIds"] = searchParams.saleTeamIds.join();
  }
  if (searchParams.ordNo) {
    params["ordNo"] = searchParams.ordNo;
  }

  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/wholesale-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

